import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { CheckOutlined } from "@ant-design/icons"
import { useAppContext } from "@components/AppContext"
import { useOutletContext } from "react-router-dom"

import { updateMyInvestmentFundingStatusOperation } from "@api/services/investments"

import InvestmentFundedInvestorModal from "./InvestmentFundedInvestorModal"
import InvestmentFundedCustodianModal from './InvestmentFundedCustodianModal'

const LABEL_FUND_SENT = "I have sent funds"
const LABEL_SUBMIT_WIRE_MODAL = "Custodian has sent funds"


const InvestmentFundedButton = ({
  isSdira,
  afterUpdate,
  hasSentFunds,
  investmentId,
}) => {
  const [ isLoading, setIsLoading ] = useState(false)
  const [ isModalOpen, setIsModalOpen ] = useState(false)

  const { updateInvestment } = useOutletContext()
  const { request } = useAppContext()

  const submitLabel = isSdira
    ? LABEL_SUBMIT_WIRE_MODAL
    : LABEL_FUND_SENT

  const openModal = () =>
    setIsModalOpen(true)

  const onCancel = () =>
    setIsModalOpen(false)

  const confirmFundsSent = () => {
    const parameters = {
      id: investmentId,
      mutation: { hasSentFunds: true }
    }

    setIsLoading(true)
    request(updateMyInvestmentFundingStatusOperation, parameters)
      .then(({ data }) => updateInvestment(data))
      .then(() => afterUpdate())
      .finally(() => {
        setIsLoading(false)
        setIsModalOpen(false)
      })
  }

  const buttonProps = {
    type: "primary",
    icon: <CheckOutlined />,
    shape: "round",
    onClick: openModal,
    disabled: hasSentFunds,
  }

  const modalProps = {
    onOk: confirmFundsSent,
    isOpen: isModalOpen,
    onCancel,
    isLoading,
  }

  const renderModal = () =>
    isSdira
      ? <InvestmentFundedCustodianModal {...modalProps} />
      : <InvestmentFundedInvestorModal {...modalProps} />

  return (
    <>
      <Button {...buttonProps}>
        {submitLabel}
      </Button>

      {renderModal()}
    </>
  )
}

InvestmentFundedButton.propTypes = {
  isSdira: PropTypes.bool.isRequired,
  afterUpdate: PropTypes.func.isRequired,
  hasSentFunds: PropTypes.bool.isRequired,
  investmentId: PropTypes.string.isRequired,
}

export default InvestmentFundedButton
